export default __webpack_public_path__ + "4c5160690c09162ec40979fbcf2e47c8.png";